import React, { useState } from "react";
import PropTypes from "prop-types";

import { K_COLORS_DARK_NAVY } from "constants.js";
import { LogoIcon as BrandLogo } from "assets/images";
import { Collapse, NavbarToggler, Navbar, NavbarBrand, Nav } from "reactstrap";
import NavItem from "./NavItem";
import BrandName from "./BrandName";
import { scrollToRef } from "../../util";

const NavigationBar = (props) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const { navName, navItems, landingRef } = props;
  return (
    <Navbar dark expand={"md"} style={styles.navbar}>
      <div onClick={() => scrollToRef(landingRef)}>
        <NavbarBrand
          style={styles.navbarBrand}
        >
          <BrandLogo size={40} />
          <BrandName name={navName} />
        </NavbarBrand>
      </div>
      <NavbarToggler
        onClick={() => {
          setIsExpanded(!isExpanded);
        }}
      />
      <Collapse isOpen={isExpanded} navbar>
        <Nav navbar className="ml-auto">
          {navItems.map((navItem) => (
            <NavItem
              label={navItem.label}
              anchorRef={navItem.anchorRef}
              key={navItem.label}
            />
          ))}
        </Nav>
      </Collapse>
    </Navbar>
  );
};

const styles = {
  navbar: {
    position: "fixed",
    top: 0,
    zIndex: 1,
    backgroundColor: K_COLORS_DARK_NAVY,
    minWidth: "100vw",
    padding: "0.75rem",
    paddingLeft: "10vw",
    paddingRight: "10vw",
    justifyContent: "space-between",
  },

  navbarBrand: {
    cursor: "pointer",
  },
};

NavigationBar.propTypes = {
  navName: PropTypes.string.isRequired,
  navItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      anchorRef: PropTypes.shape().isRequired,
    }),
  ).isRequired,
  landingRef: PropTypes.shape().isRequired,
};

export default NavigationBar;
